'use strict';

window.TIPOS_OCORRENCIAS_MAQUINAS = [
  { id: 'manutencao', descricao: 'Manutenção' },
  { id: 'reforma', descricao: 'Reforma' },
  { id: 'reparo', descricao: 'Reparo' }
];

window.TIPOS_CONTROLE_MAQUINA = {
  horimetro: 'Horímetro Atual',
  quilometragem: 'km Atual'
};

window.TIPOS_STATUS_OCORRENCIA_MAQUINA = {
  aberto: {
    id: 'aberto',
    descricao: 'Aberto'
  },
  fechado: {
    id: 'fechado',
    descricao: 'Fechado'
  },
  atrasado: {
    id: 'atrasado',
    descricao: 'Em Atraso'
  },
  checado: {
    id: 'checado',
    descricao: 'Checado'
  },
  checagem_atrasada: {
    id: 'checagem_atrasada',
    descricao: 'Checagens atrasadas'
  }
};

angular.module('webAgro1App').factory(
  'OcorrenciasMaquinasService',
  // eslint-disable-next-line max-params, complexity, max-lines-per-function
  function($http, $q, $filter, filterFilter, RestService, OcorrenciaMaquinaObjectService) {
    // eslint-disable-next-line complexity
    const getFilters = function(filters) {
      const result = !filters ? {} : {
        id: filters.id || null,
        data_inicial: filters.dataInicial || null,
        data_final: filters.dataFinal || null,
        page: filters.page || null,
        maquina: (filters.maquina || {}).id || null,
        operador: (filters.operador || {}).id || null,
        tipo: (filters.tipo || {}).id,
        item_manutencao: (filters.itemManutencao || {}).id
      };

      if ((filters.status || {}).id) {
        result.atrasadas = filters.status.id === TIPOS_STATUS_OCORRENCIA_MAQUINA.atrasado.id;
        result.checagens_atrasadas = filters.status.id === TIPOS_STATUS_OCORRENCIA_MAQUINA.checagem_atrasada.id;
        if (!result.atrasadas && !result.checagens_atrasadas) {
          result.status = filters.status.id;
        }
      }

      return result;
    };

    return {
      getTipo: function(tipo) {
        return filterFilter(TIPOS_OCORRENCIAS_MAQUINAS, { id: tipo }, true)[0] || {};
      },

      list: function(filters) {
        const params = getFilters(filters);
        return RestService.getFromUrl(`${SERVER + API_VERSION }boletim_ocorrencias`, params);
      },

      listOcorrenciaMaquina: function(id) {
        const url = `${SERVER + API_VERSION }boletim_ocorrencias/${ id || ''}`;
        return $http.get(url);
      },

      summary: function(filters) {
        const params = getFilters(filters);
        return $http.get(`${SERVER + API_VERSION }boletim_ocorrencias/resumo`, { params: params });
      },

      save: function(ocorrencia) {
        const result = OcorrenciaMaquinaObjectService.convertToSend(ocorrencia);
        return $http({
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          url: `${SERVER + API_VERSION }boletim_ocorrencias`,
          data: { ocorrencias: [result] }
        });
      },

      update: function(ocorrencia) {
        const result = OcorrenciaMaquinaObjectService.convertToSend(ocorrencia);
        return $http({
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
          url: `${SERVER + API_VERSION }boletim_ocorrencias/${ result.id}`,
          data: { ocorrencia: result }
        });
      },

      delete: function(id) {
        return $http.delete(`${SERVER + API_VERSION }boletim_ocorrencias/${ id}`);
      },

      getOcorrenciaMaquina: function(id) {
        const deferred = $q.defer();

        this.listOcorrenciaMaquina(id).then(function(data) {
          const ocorrencia = OcorrenciaMaquinaObjectService.convertToObject(data.data);
          deferred.resolve(ocorrencia);
        }, deferred.reject);

        return deferred.promise;
      },

      saveComment: function(ocorrencia) {
        const url = `${SERVER + API_VERSION }boletim_ocorrencias/${ ocorrencia.id }/comentarios`;
        return $http({
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          url: url,
          data: { comentario: { comentario: ocorrencia.comentario } }
        });
      },

      validateCheck: function(ocorrencia) {
        const url = `${SERVER + API_VERSION }boletim_ocorrencias/${ ocorrencia.id }/check`;
        return $http({
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          url: url
        });
      },

      deleteComment: function(idOcorrencia, idComentario) {
        const url = `${SERVER + API_VERSION }boletim_ocorrencias/${ idOcorrencia }/comentarios/${ idComentario}`;
        return $http.delete(url);
      },

      doSaveClose: function(ocorrencia) {
      // eslint-disable-next-line max-len
        const dataHora = `${$filter('date')(ocorrencia.fechado.data, DATE_FORMAT) } ${ $filter('date')(ocorrencia.fechado.hora, HOUR_FORMAT)}`;
        const dataPrazoChecagem = $filter('date')(ocorrencia.fechado.dataPrazoChecagem, DATE_FORMAT);
        const url = `${SERVER + API_VERSION }boletim_ocorrencias/${ ocorrencia.id }/close`;
        const dados = {
          ocorrencia: {
            comentario: ocorrencia.fechado.comentario || null,
            data_hora: dataHora,
            data_prazo_checagem: dataPrazoChecagem,
            data_fechamento: new Date(),
            negligencia: ocorrencia.negligencia
          }
        };

        return $http({
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          url: url,
          data: dados
        });
      }
    };
  }
);
